<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { configurationStore } from '@/modules/configurationModule/store/configuration.store'

export default {
    name: 'ConfigurationIndex',
    beforeCreate() {
        configurationStore.register()
    },
    beforeDestroy() {
        configurationStore.unregister()
    }
}
</script>

<style lang="scss">
    .configuration-grid {
        box-shadow: 0 0 4px #cbcbcb;
        height: 100%;
    }
    .configuration-box {
        box-shadow: 0 0 4px #cbcbcb;
        flex-grow: 1;
        overflow-y: auto;
    }
    .configuration-grid .ag-root-wrapper-body.ag-layout-normal {
        padding: 5px;
    }
    .configuration-detail .configuration-section-header small {
        text-transform: uppercase;
    }
</style>
